export default __webpack_public_path__ + "static/Glass-0af3accb6553d7ae3e21ed768b531171.jpg";